import { Activity } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Состояние системы (БО-70; DODOC_ADMIN, DODOC_SUPPORT, DODOC_QA): очереди, скрайб, провайдеры, WhatsApp, ошибки. */
export const section = defineSection({
  id: 'backoffice.system',
  area: 'backoffice',
  path: 'system',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT', 'DODOC_QA'],
  icon: Activity,
  titleKey: 'boSystem:title',
  namespaces: ['backoffice'],
  navGroup: 'system',
  order: 10,
  load: () => import('./SystemPage'),
});
